import { useLayoutEffect } from 'react'
import { Card, Typography } from 'antd'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { t } from 'i18next'

import { EForgotPasswordPageType, PATH_LOGIN } from '@configs'
import {
  ForgotPasswordForm,
  ResetPasswordForm,
  VerifyEmailForm,
} from '@components'
import {
  RootState,
  selectAuth,
  selectAuthLoading,
  useAppSelector,
} from '@redux'
import { IMAGES } from '@assets'
import { StyledAuthenContainer } from 'src/components/auth/loginStyle'

export const ForgotPasswordPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const { hash, forgotEmail } = useAppSelector(selectAuth)
  const forgotPasswordActionLoading = useSelector((state: RootState) => {
    return selectAuthLoading(state, 'forgotPasswordAction')
  })
  const verifyPasswordActionLoading = useSelector((state: RootState) => {
    return selectAuthLoading(state, 'verifyPasswordAction')
  })
  const resetPasswordActionLoading = useSelector((state: RootState) => {
    return selectAuthLoading(state, 'resetPasswordAction')
  })

  const pageType = searchParams.get('type') as EForgotPasswordPageType | null

  const formatTitle = (string: string | null) => {
    const formattedTitle = string
      ? string.split('-').join(' ')
      : 'Forgot Password'

    return formattedTitle
  }

  const handleRedirectToLogin = () => {
    navigate(PATH_LOGIN)
  }

  const renderForm = () => {
    switch (pageType) {
      case EForgotPasswordPageType.VERIFY_EMAIL:
        return (
          <VerifyEmailForm
            isLoading={verifyPasswordActionLoading}
            onBack={handleRedirectToLogin}
          />
        )
      case EForgotPasswordPageType.RESET_PASSWORD:
        return (
          <ResetPasswordForm
            redirectToLogin={handleRedirectToLogin}
            isLoading={resetPasswordActionLoading}
          />
        )
      default:
        return (
          <ForgotPasswordForm
            redirectToLogin={handleRedirectToLogin}
            isLoading={forgotPasswordActionLoading}
          />
        )
    }
  }

  useLayoutEffect(() => {
    if (
      pageType === EForgotPasswordPageType.RESET_PASSWORD &&
      (!hash || !forgotEmail)
    ) {
      navigate(PATH_LOGIN)
    }
  }, [hash, forgotEmail, pageType, navigate])

  return (
    <StyledAuthenContainer>
      <div className="min-w-[520px] max-w-[600px]">
        <img
          src={IMAGES.llcTeacherBlackLogo}
          alt=""
          className="logo max-w-[160px] mx-auto mb-6"
        />
        <Typography.Title
          level={3}
          className="capitalize text-center text-[28px]"
        >
          {formatTitle(pageType)}
        </Typography.Title>
        {renderForm()}
      </div>
    </StyledAuthenContainer>
  )
}
